import { TripStepTypeEnum } from '../../lib/types/enums/trip-bookings/trip-step-type.enum'
import { TripBasic } from '../../lib/types/models/trip/trip'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

type CenterTripBookingsTripsFilters = {
  directionalities: TripStepTypeEnum[]
  tripIds: number[]
}

export function getCenterTripBookingsTrips(id: number, filters?: CenterTripBookingsTripsFilters) {
  return restApiClient
    .url(
      encodeNestedObject(
        constructApiUrl(API.centers.getCenterTripBookingsTrips.url, { id }),
        filters
      )
    )
    .get<TripBasic[]>()
}
